import { render, staticRenderFns } from "./AuthorityManage.vue?vue&type=template&id=4c600df2&"
import script from "./AuthorityManage.vue?vue&type=script&lang=js&"
export * from "./AuthorityManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports